import type { FormKitSchemaFormKit } from '@formkit/core'
import { CAPTCHA_CHECKBOX_ID } from '../../constants/CAPTCHA_CHECKBOX_ID'

export function addCaptcha(formSchema: FormKitSchemaFormKit[]) {
  return [
    ...(formSchema || []),
    {
      'name': CAPTCHA_CHECKBOX_ID,
      'validation': 'required',
      '$formkit': 'captchaCheckbox',
      'validation-label': 'Captcha',
    },
  ]
}
